<app-legal-layout>
  <h1 data-testid="terms-title">Text Messaging Terms of Use</h1>
  <p>Last modified: July 1, 2025</p>
  <p>
    By “Opting In” to or using a “Text Message Service” (as defined below) from Monarch Specialty Group LLC (“<b>Company</b>” or
    “<b>We</b>”), you accept these Terms & Conditions. This agreement is between you and Company.
  </p>
  <h2>Definitions</h2>
  <p>
    “Opting In,” “Opt In,” and “Opt-In” refer to requesting, joining, agreeing to, enrolling in, signing up for, acknowledging, responding
    to, or otherwise consenting to receive one or more text messages.
  </p>
  <p>
    “Text Message Service” includes any arrangement or situation in which we send one or more messages addressed to your mobile phone
    number, including text messages (such as SMS, MMS, or successor protocols or technologies).
  </p>
  <h2>Consenting to Text Messaging</h2>
  <p>
    By consenting to receive text messages from us, you agreed to these Text Messaging Terms and Conditions, as well as our
    <a href="privacy-policy" target="_blank">Privacy Policy</a>, incorporated herein by reference.
  </p>
  <h2>E-Sign Disclosure</h2>
  <p>
    By agreeing to receive text messages, you also consent to the use of an electronic record to document your agreement. You may withdraw
    your consent to the use of the electronic record by replying STOP.
  </p>
  <h2>Text Message Service Privacy Policy</h2>
  <p>
    We respect your privacy. We only use information you provide through this service to transmit your mobile messages and respond to you.
    This includes, but isn’t limited to, sharing information with platform providers, phone companies, and other vendors who assist us in
    the delivery of mobile messages. Mobile information will not be sold or shared with third parties/affiliates for marketing/promotional
    purposes. All the above categories exclude text messaging originator optin data and consent; this information will not be sold or shared
    with any third parties. Nonetheless, we reserve the right always to disclose any information as necessary to satisfy any law, regulation
    or governmental request, to avoid liability, or to protect our rights or property. This Text Message Service Privacy Policy applies to
    your use of the Text Message Service and isn’t intended to modify our general Privacy Policy referenced in “Consenting to Text
    Messaging”, incorporated by reference above, which may govern the relationship between you and us in other contexts.
  </p>
  <h2>Costs of Text Messages</h2>
  <p>
    We do not charge you for the messages you send and receive via this text message service. But message and data rates may apply, so
    depending on your plan with your wireless or other applicable provider, you may be charged by your carrier or other applicable provider.
  </p>
  <h2>Frequency of Text Messages</h2>
  <p>
    This Text Messaging Service is for conversational person-to-person communication between you and our employees. We may send you an
    initial message providing details about the service. After that, the number of text messages you receive will vary depending on how you
    use our services and whether you take steps to generate more text messages from us (such as by sending a HELP request).
  </p>
  <h2>Opting Out of Text Messages</h2>
  <p>
    If you no longer want to receive text messages, you may reply to any text message with STOP, QUIT, END, REVOKE, OPT OUT, CANCEL, or
    UNSUBSCRIBE. As a person-to-person communication service, opt-out requests are specific to each conversation between you and one of our
    employees and their associated phone number. After unsubscribing, we may send you confirmation of your opt-out via text message.
  </p>
  <h2>Contact Information</h2>
  <p>
    To ask questions or comment about this Text Messaging Terms of Use, our Privacy Policy or our privacy practices, please contact us at:
  </p>
  <p>
    <a href="mailto:{{ email() }}">{{ email() }}</a>
  </p>
  <p>or via phone:</p>
  <p>
    <a href="tel:{{ phone() }}">{{ phone() }}</a>
  </p>
</app-legal-layout>
